import React, { useEffect, useState, useRef } from 'react';
import { Menu, X } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
const navItems = [{
  label: 'Nosotros',
  href: '#about'
}, {
  label: 'Galería',
  href: '#gallery'
}, {
  label: 'Estilos',
  href: '#styles'
}, {
  label: 'Estudio',
  href: '#studio'
}, {
  label: 'Opiniones',
  href: '#testimonials'
}, {
  label: 'Redes',
  href: '#social'
}, {
  label: 'Ubicación',
  href: '#map-section'
}];
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    if (menuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);
  return <nav className={`fixed top-0 left-0 right-0 z-50 flex justify-between items-center transition-all duration-300 bg-black/95 backdrop-blur-md border-b border-gold/20 ${scrolled ? 'py-3 px-6 md:px-10 lg:px-[60px] shadow-[0_4px_30px_rgba(201,168,76,0.1)]' : 'py-[18px] px-6 md:px-10 lg:px-[60px]'}`} data-id="element-188">
      <div className="font-cinzel text-[1.4rem] font-black text-gold tracking-[4px] uppercase" data-id="element-189">
        SOLIDO <span className="text-white" data-id="element-190">TATTOO</span>
      </div>

      <div className="flex items-center gap-4" ref={menuRef} data-id="element-191">
        <div className="relative" data-id="element-192">
          <button onClick={() => setMenuOpen(!menuOpen)} className="text-gold p-1.5 border border-gold/20 transition-all duration-300 hover:border-gold hover:bg-gold/5" aria-label="Menú de navegación" data-id="element-193">
            {menuOpen ? <X size={22} data-id="element-194" /> : <Menu size={22} data-id="element-195" />}
          </button>

          <AnimatePresence data-id="element-196">
            {menuOpen && <motion.div initial={{
            opacity: 0,
            y: -10,
            scaleY: 0.95
          }} animate={{
            opacity: 1,
            y: 0,
            scaleY: 1
          }} exit={{
            opacity: 0,
            y: -10,
            scaleY: 0.95
          }} transition={{
            duration: 0.25,
            ease: 'easeOut'
          }} className="absolute top-full right-0 mt-1 bg-[#0a0a0a] border border-gold/20 min-w-[180px] origin-top shadow-[0_10px_30px_rgba(0,0,0,0.9)]" data-id="element-197">
                <div className="py-1.5" data-id="element-198">
                  {navItems.map((item, i) => <motion.a key={item.label} href={item.href} onClick={() => setMenuOpen(false)} initial={{
                opacity: 0,
                x: -10
              }} animate={{
                opacity: 1,
                x: 0
              }} transition={{
                delay: i * 0.03,
                duration: 0.15
              }} className="flex items-center gap-2.5 px-4 py-2 text-[0.65rem] font-semibold tracking-[2px] uppercase text-gray transition-all duration-300 hover:text-gold hover:bg-gold/5 hover:pl-5" data-id="element-199">
                      <span className="w-1.5 h-1.5 bg-gold/30 rounded-full" data-id="element-200"></span>
                      {item.label}
                    </motion.a>)}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>

        <a href="#booking" className="bg-transparent border border-gold text-gold px-[18px] py-1.5 text-[0.65rem] tracking-[2px] uppercase cursor-pointer transition-all duration-300 font-raleway font-semibold hover:bg-gold hover:text-black sm:px-[22px] sm:py-2 sm:text-[0.7rem] sm:tracking-[3px]" data-id="element-201">
          Reservar
        </a>
      </div>
    </nav>;
}